import {SettingsModel} from "../settings/models/settings";
import {SettingsView} from "../settings/views/settings";
import {MasterView} from "../shared/views/master-view";
import {autoinject} from "aurelia-dependency-injection";
import {AppEvents} from "../app-events";
import {Container} from "aurelia-dependency-injection";
import {MobileHelper} from "../shared/helpers/mobile-helper";
import { AuthService } from "../authentication/auth-service";

require("../settings/styles/settings.less");
require("../settings/styles/source-link-settings.less");
require("../settings/styles/search-settings.less");

@autoinject
export class SettingsModule extends Backbone.Model  {

    constructor(
        private appEvents: Backbone.Events,
        private settingsView: SettingsView,
        private settingsModel: SettingsModel,
        private masterView: MasterView,
        private authService: AuthService) {
        super();
        this.setupViews();
    }

    public openOrClose() {
        const mh: MobileHelper = Container.instance.get(MobileHelper);
        if (mh.IsMobileMode) {
            if (this.settingsModel.Open) { return; }
            this.mobileOpen();
        } else {
            if (this.settingsModel.Open) {
                this.close();
            } else {
                this.open();
            }
        }
    }

    public hide(): void {
        this.close();
        $("#settings-button").removeClass("selected");
    }

    public close() {
        $("#viewport").removeClass("shift");
        this.settingsModel.Open = false;
        this.appEvents.trigger(AppEvents.RefreshResultsPagerPopup, { SettingPanelActive: false });
    }

    public reset(): void {
        const userSettings = this.settingsModel.UserSettings;
        const jds = userSettings.CoreJurisdictions;
        while (jds && jds.models.length > 0) {
            const current = jds.models[0];
            const children = current.Children;
            while (children.models.length > 0) {
                children.models[0].remove();
            }

            jds.models[0].remove();
        }
        userSettings.remove();

        const sourceLinkSettings = this.settingsModel.SourceLinkSettings;
        sourceLinkSettings.remove();

        if (this.settingsModel.Open) {
            this.close();
        }

        this.settingsModel.UserSettings.Populated = false;
        this.settingsModel.SourceLinkSettings.Populated = false;
        this.settingsView.resetViews();
    }

    private setupViews(): void {
        this.listenToOnce(this.masterView, "render", () => {
            const region = this.masterView.addRegion("settingsRegion", "#settings-region");
            region.show(this.settingsView);
        });
        this.listenTo(this.authService.AppUser, "refresh", () => {
            this.reset();
        });
    }

    private open(): void {
        $("#viewport").addClass("shift").one("click", (e) => {
            this.close();
            $("#settings-button").removeClass("selected");
        });
        this.settingsModel.Open = true;
        this.appEvents.trigger(AppEvents.RefreshResultsPagerPopup, { SettingPanelActive: true });
    }

    private mobileOpen(): void {
        $("#mobile-nav-menu li").on("click", (e) => { // Get settings to close once we click one of the other mobile nav buttons
            e.preventDefault();
            if ($(e.currentTarget).hasClass("disabled") || $(e.currentTarget).hasClass("settings")) { // Doesn't happen if you click a disabled button (or the settings button again)
                return;
            }

            $("#mobile-nav-menu li").off("click"); // unbind this event once you've navigated away from settings
            this.close();
        });
        this.settingsModel.Open = true;
        this.appEvents.trigger(AppEvents.RefreshResultsPagerPopup, { SettingPanelActive: true });

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/settings-module.ts